/**
 *
 * @type {ZoneGroupId}
 */
export const DEFAULT_ZONE_GROUP_ID = 0;
